import { createSlice } from '@reduxjs/toolkit';

const domainSlice = createSlice({
  name: 'domain',
  initialState: {
    partnerDetail: null,
  },
  reducers: {
    setDomainData: (state, action) => {
      state.partnerDetail = action.payload;
    },
  },
});

export const { setDomainData } = domainSlice.actions;
export default domainSlice.reducer;